import React from 'react';
import { markupHelpers } from '../../../helpers/index';
import dateFormat from 'dateformat';
import * as Buttons from '../../ui/buttons';
import { getFullMonthYear } from './../../../../../../../helpers/common/date-util';

export const PublicationItem = props => {
	const {
		title,
		publisher,
		publication_date,
		author,
		description,
		buttonHandlers,
		url,
		guestMode,
	} = props;

	const convertedTitle = markupHelpers.escapeHtmlHelper(title),
		convertedPublisher = markupHelpers.escapeHtmlHelper(publisher),
		convertedAuthor = markupHelpers.escapeHtmlHelper(author),
		convertedDescription = markupHelpers.escapeHtmlHelper(description);

	return (
		<div className="item-achievements publications">
			{/*show when not in guestMode*/}
			{!guestMode && (
				<div className="item-display-mode">
					<Buttons.EditButton {...buttonHandlers} />
				</div>
			)}
			{/*/////////*/}
			<div className="row">
				<div className="col-4 col-lg-3 new-profile-label">Title</div>
				<div
					className="col-8 col-lg-9 new-profile-info item-header"
					dangerouslySetInnerHTML={{ __html: convertedTitle }}
				/>
			</div>
			{author && (
				<div className="row">
					<div className="col-4 col-lg-3 new-profile-label">Author</div>
					<div
						className="col-8 col-lg-9 new-profile-info"
						dangerouslySetInnerHTML={{ __html: convertedAuthor }}
					/>
				</div>
			)}
			{publisher && (
				<div className="row">
					<div className="col-4 col-lg-3 new-profile-label">Publisher</div>
					<div
						className="col-8 col-lg-9 new-profile-info"
						dangerouslySetInnerHTML={{ __html: convertedPublisher }}
					/>
				</div>
			)}
			{!url || url === 'null' ? null : (
				<div className="row">
					<div className="col-4 col-lg-3 new-profile-label">Url</div>
					<div className="col-8 col-lg-9 new-profile-info">
						{url.includes('http') ? (
							<a href={url} target="_blank">
								{url}
							</a>
						) : (
							<a href={`http://${url}`} target="_blank">
								{url}
							</a>
						)}
					</div>
				</div>
			)}

			{!publication_date || publication_date === null ? null : (
				// todo - catch below was added as some 4000 recordes have no start date from when this wasn't required field
				<div className="row">
					<div className="col-4 col-lg-3 new-profile-label">Date</div>
					<div className="col-8 col-lg-9 new-profile-info">
						{ getFullMonthYear( publication_date ) }
					</div>
				</div>
			)}

			{!description || description === 'null' ? null : (
				<div className="row">
					<div className="col-4 col-lg-3 new-profile-label">Description</div>
					<div
						className="col-8 col-lg-9 new-profile-info editor"
						dangerouslySetInnerHTML={{ __html: convertedDescription }}
					/>
				</div>
			)}
		</div>
	);
};



// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/body/achievements/PublicationItem.js